export type Bonus = {
  number: string
  name: string
  summary: string
  includes: string
  idealFor: string
  pages: string
  value: number
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    name: 'Professional Client Forms Toolkit',
    summary:
      'Get ready-to-use professional documentation templates to organize client information before, during, and after sports massage appointments.',
    includes:
      'Includes client profiles, health information forms, body maps, consent records, treatment notes, client response documentation, and practical professional recordkeeping tools.',
    idealFor: 'Ideal for therapists who want their client documentation organized in one place.',
    pages: '25 Pages of Professional Forms & Templates',
    value: 12,
  },
  {
    number: '02',
    name: 'Therapist Body Protection Toolkit',
    summary: 'A practical professional resource focused on managing the physical demands of massage work.',
    includes:
      'Includes table-height adjustments, wrist and hand contact alternatives, body positioning, therapist working distance, workload organization, and practical techniques for modifying demanding working situations.',
    idealFor: 'Designed to help practitioners make informed adjustments during their daily work.',
    pages: '25 Pages of Practical Body Mechanics & Workload Tools',
    value: 12,
  },
  {
    number: '03',
    name: 'Athlete Aftercare Handouts',
    summary:
      'A collection of client-facing information sheets that professionals can personalize and share after appropriate massage sessions.',
    includes:
      'Includes general aftercare guidance, body-region-specific handouts, training considerations, post-event information, travel-related considerations, and guidance on when clients should seek additional assessment.',
    idealFor: 'Ideal for giving clients clear, professional information after appointments.',
    pages: '25 Pages of Printable & Customizable Athlete Handouts',
    value: 15,
  },
  {
    number: '04',
    name: 'Sports Event Preparation Toolkit',
    summary:
      'Practical resources for therapists providing services at competitions, tournaments, races, and sporting events.',
    includes:
      'Includes equipment packing checklists, treatment station layouts, appointment scheduling tools, hygiene workflows, event-day coordination, supply planning, and operational contingency resources.',
    idealFor: 'Everything organized to help you prepare your professional event setup.',
    pages: '25 Pages of Event Checklists & Organization Tools',
    value: 12,
  },
  {
    number: '05',
    name: 'Client Follow-Up & Retention Toolkit',
    summary: 'Ready-to-personalize professional communication templates for everyday client management.',
    includes:
      'Includes appointment confirmations, reminders, client check-ins, rescheduling messages, optional rebooking invitations, feedback replies, and respectful client reconnection templates.',
    idealFor: 'Designed to help professionals communicate clearly and manage their client relationships.',
    pages: '25 Pages of Professional Message Templates',
    value: 10,
  },
]

export const pricing = {
  bonusValue: 61,
  price: '26.90',
}

export const checkoutFeatures = [
  'Lower Body + Upper Body Protocols',
  'Step-by-Step Regional Techniques',
  'Pre-Event + Post-Event + Maintenance Massage',
  'Sport-Specific Sessions',
  '30-, 45- & 60-Minute Examples',
  'Client Positioning + Practical Adaptations',
  'Professional Client Forms & Tools',
  'Instant Digital Access',
  '7-Day Guarantee',
]
